import CalendarModuleCommanding from './CalendarModuleCommanding';
import { observer } from 'mobx-react-lite';
import { CalendarModuleBoard } from 'owa-calendar-board-view';
import { isBoardViewTypeSelected } from 'owa-calendar-module-store';
import { getSearchState } from 'owa-calendar-search-view-store';
import { SearchResultsView } from 'owa-calendar-searchresults-view';
import { CalendarModuleSurface } from 'owa-calendar-surface-view';
import * as React from 'react';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module
// This file will be further decomposed in upcoming iterations to fully separate surface and board

const styles = require('./CalendarModule.scss');

export default observer(function CalendarModuleContent() {
    const isSurfaceViewType = !isBoardViewTypeSelected();

    if (getSearchState()) {
        return <SearchResultsView />;
    }

    return (
        <div className={styles.moduleContent}>
            <CalendarModuleCommanding />
            {isSurfaceViewType ? <CalendarModuleSurface /> : <CalendarModuleBoard />}
        </div>
    );
});
